/** Keep in step with the server's DATABASE_ENTITY_STATUS_FLAGS. */
export const STATUS_FLAGS = [
  'new',
  'not_reviewed',
  'quarantined',
  'cleared',
  'barred',
] as const;

export type StatusFlag = (typeof STATUS_FLAGS)[number];

export const isStatusFlag = (value: unknown): value is StatusFlag =>
  typeof value === 'string' &&
  (STATUS_FLAGS as readonly string[]).includes(value);
